import { PublicClientApplication } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: 'fc3e525d-dc3e-4aaf-a892-ab5d48134bfe',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: '/',
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
};

export const loginScopes = {
  scope: ['User.Read'],
};

export const pca = new PublicClientApplication(msalConfig);
